import home from './home.json';

export default {
    home
}